import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ecommerce',
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.scss']
})
export class EcommerceComponent {

  products = [
    {
      "id":1,
      "name":"NOPCommerce",
      "img":"nopCommerce.png",
      "description":"Sync customers, orders and products."
    }
  ];
  displayMoreInfo = false;
  fullInfo;
  showInstall = true;
  showSpin = false;
  showInstalled = false;
  displayConnection = false;
  showSetup = false;
  tempConnection = {
    "id":0,
    "clientID":"",
    "token":""
  }

  dataView = true;
  ecommerceData = [
    {
      "id":1,
      "name":"Accouts",
      "dataSource":"LionO",
      "isActive":true,
      "status":true,
    },
    {
      "id":2,
      "name":"Products",
      "dataSource":"LionO",
      "isActive":false,
      "status":true,
    },
    {
      "id":3,
      "name":"Order sync",
      "dataSource":"Nop",
      "isActive":true,
      "status":false,
    },
    {
      "id":4,
      "name":"Order status",
      "dataSource":"LionO",
      "isActive":true,
      "status":false,
    },
    {
      "id":5,
      "name":"Credit Memo",
      "dataSource":"LionO",
      "isActive":true,
      "status":false,
    },
  ]
  assestBaseUrl: string = environment.assestsBasePath;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) { }

  installBtn(){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.showInstall = false;
        this.showSpin = true;
        setTimeout(() => {
          this.showSpin = false;
          this.showInstalled = true;
          this.showSetup = true;
        }, 5000);
      }
    });
  }

  uninstallBtn(){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.showInstalled = false;
        this.showInstall = true;
        this.showSetup = false;
      }
    });
  }
  changeTableView(){
    this.dataView = false;
  }
  backDataView(){
    this.dataView = true;
  }
  editConnect(){
    this.tempConnection = {
      "id":1,
      "clientID":"gdfs-29sd-2uid-2879-iuwe",
      "token":"sdf4-j42s-tr5i-yjw4"
    }
    this.displayConnection = true;
  }
  copyInputMessage(inputElement){
    inputElement.disabled = false;
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    inputElement.disabled = true;
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Copied successfully' });
  }

  showMoreInfo(c){
    this.fullInfo = JSON.parse(JSON.stringify(c));
    this.displayMoreInfo = true;
  }

  confirm(data) {
    this.confirmationService.confirm({
        message: "Are you sure that you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Cancel",
        accept: () => {
            data.isActive = !data.isActive;
        },
    });
  }

  confirm2(data){
    this.confirmationService.confirm({
      message: "Are you sure that you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      accept: () => {
          data.status = !data.status;
      },
  });
  }

}
